import anime from 'animejs';
import { createAnimation } from '@/assets/js/utils/createAnimation';
import { characterWalk } from '@/assets/js/utils/characterWalk';
import { createRotateAnimation } from '@/assets/js/utils/createRotateAnimation';

const devyn_animations = () => {
  return {
    enter(options) {
      return createAnimation((tl, options) => {
        options.duration = options.duration || 3500
        tl
          .add({
            targets: '#devyn',
            translateY: characterWalk(options.duration),
            right: ['65%', '80%'],
            easing: 'linear',
            duration: options.duration,
            begin: options.begin,
            complete: options.complete
          })
      }, options, this)()
    },
    exit(options) {
      return createAnimation((tl, options) => {
        options.duration = options.duration || 3500
        tl
          .add({
            targets: '#devyn',
            scaleX: {
              value: -1,
              duration: 1
            }, // maintain flipped X
            translateY: characterWalk(options.duration),
            right: ['25%', '-20'],
            easing: 'linear',
            duration: options.duration,
            begin: options.begin,
            complete: options.complete
          })
      }, options, this)()
    },
    rotate(options) {
      return createAnimation(createRotateAnimation("#devyn"), options, this)()
    },
    walk(options) {
      return createAnimation((tl, options) => {
        options.duration = options.duration || 8000
        options.flipped = options.flipped || false
        tl
          .add({
            targets: '#devyn',
            scaleX: {
              value: options.flipped ? -1 : 1,
              duration: 1
            }, // flip aye conditionally
            left: options.left, // gradually move closer to left side of scene.
            translateY: characterWalk(options.duration),
            easing: 'linear',
            duration: options.duration,
            begin: options.begin,
            complete: options.complete
          })
      }, options, this)()
    },
    wink(options) {
      return createAnimation((tl, options) => {
        tl
          .add({ // keep right eyelid open during wink animation
            targets: '#devyn_right_eye_lids',
            opacity: 0,
            duration: 500
          })
        tl
          .add({
            targets: '#devyn_left_eye_lids',
            opacity: 1,
            duration: 250,
            begin: options.begin,
            offset: "-=500" // start left animation at same time as right animation
          })
          .add({
            targets: '#devyn_left_eye_lids',
            opacity: 0,
            duration: 100,
            delay: 350,
            complete: options.complete,
          })
      }, options, this)()
    },
    laugh(options) {
      return createAnimation((tl, options) => {
        tl
        .add({ // close and open eyes
          targets: '#devyn_right_eye_lids, #devyn_left_eye_lids',
          opacity: 1,
          duration: 1,
          begin: options.begin
        })
        .add({
          targets: '#devyn_right_eye_lids, #devyn_left_eye_lids',
          opacity: 1,
          duration: 1199,
        })
        .add({
          targets: '#devyn_right_eye_lids, #devyn_left_eye_lids',
          opacity: 0,
          duration: 1
        })
        .add({ // raise left arm and forearm
          targets: '#devyn_left_arm',
          rotate: '50deg',
          duration: 500,
          easing: "linear",
          offset: "-=1200"
        })
        .add({
          targets: '#devyn_left_arm_hand',
          rotate: '140deg',
          duration: 300,
          easing: "linear",
          offset: "-=1200"
        })
        .add({ // move outer arm group up/down
          targets: '#devyn_left_arm_outer',
          translateY: [
            {value: '-3px', duration: 150},
            {value: '0px', duration: 150},
            {value: '-3px', duration: 150},
            {value: '0px', duration: 150}
          ],
          easing: "linear",
          offset: "-=700", // start after left arm is raised
        })
        .add({ // empty selector just to chain this callback at the end.
          targets: "#null",
          duration: 1,
          complete: () => {
            this.lowerLeftArm({
              delay: 300,
              complete: options.complete
            })
          }
        })
      }, options, this)()
    },
    wave(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: '#devyn_left_arm',
            rotate: '25deg',
            duration: 350,
            easing: "linear",
            begin: options.begin
          })
          .add({
            targets: '#devyn_left_arm_hand',
            rotate: '130deg',
            duration: 300,
            easing: "linear"
          })

          // wave
          .add({
            targets: '#devyn_left_arm_hand',
            rotate: '140deg',
            duration: 300,
            easing: "linear"
          })
          .add({
            targets: '#devyn_left_arm_hand',
            rotate: '130deg',
            duration: 300,
            easing: "linear"
          })
          .add({
            targets: '#devyn_left_arm_hand',
            rotate: '140deg',
            duration: 300,
            easing: "linear"
          })
          .add({
            targets: '#devyn_left_arm_hand',
            rotate: '130deg',
            duration: 350,
            easing: "linear",
            complete: () => {
              this.lowerLeftArm({
                delay: 350,
                complete: options.complete
              })
            }
          })
      }, options, this)()
    },
    raiseLeftArm(options) {
      return createAnimation((tl, options) => {
        tl
        .add({
          targets: '#devyn_left_arm_hand',
          rotate: '120deg',
          duration: 300,
          easing: "linear",
          begin: options.begin
        })
        .add({
          targets: '#devyn_left_arm',
          rotate: '20deg',
          duration: 350,
          easing: "linear",
          complete: options.complete
        })
      }, options, this)()
    },
    lowerLeftArm(options) {
      return createAnimation((tl, options) => {
        tl
        .add({
          targets: '#devyn_left_arm_hand',
          rotate: '0deg',
          duration: 300,
          easing: "linear",
          begin: options.begin
        })
        .add({
          targets: '#devyn_left_arm',
          rotate: '0deg',
          duration: 350,
          easing: "linear",
          complete: options.complete
        })
      }, options, this)()
    },
    raiseRightArm(options) {
      return createAnimation((tl, options) => {
        // if (options.half) {
          tl
            .add({
              targets: '#devyn_right_arm',
              rotate: '20deg',
              duration: 350,
              easing: "linear",
              begin: options.begin
            })
            .add({
              targets: '#devyn_right_arm_hand',
              rotate: '72deg',
              duration: 350,
              easing: "linear",
              complete: options.complete
            })
        // } else if (options.handshake) {
        //   tl
        //   .add({
        //     targets: '#devyn_right_arm',
        //     rotate: '45deg',
        //     duration: 350,
        //     easing: "linear",
        //     begin: options.begin
        //   })
        //   .add({
        //     targets: '#devyn_right_arm_hand',
        //     rotate: '30deg',
        //     duration: 350,
        //     easing: "linear",
        //     complete: options.complete
        //   })
        // } else {
        //   tl
        //     .add({
        //       targets: '#devyn_right_arm',
        //       rotate: '50deg',
        //       duration: 350,
        //       easing: "linear",
        //       begin: options.begin
        //     })
        //     .add({
        //       targets: '#devyn_right_arm_hand',
        //       rotate: '45deg',
        //       duration: 350,
        //       easing: "linear",
        //       complete: options.complete
        //     })
        // }
      }, options, this)()
    },
    lowerRightArm(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: '#devyn_right_arm_hand',
            rotate: '0deg',
            duration: 350,
            easing: "linear",
            begin: options.begin
          })
          .add({
            targets: '#devyn_right_arm',
            rotate: '0deg',
            duration: 350,
            easing: "linear",
            complete: options.complete
          })
      }, options, this)()
    },
    handShake(options) {
      return createAnimation((tl, options) => {
        this.raiseRightArm({
          handshake: true,
          complete: () => {
            tl
            .add({
              targets: '#devyn_right_arm_hand',
              rotate: '18deg', // bump down by 12deg
              duration: 350,
              easing: "linear"
            })
            .add({
              targets: '#devyn_right_arm_hand',
              rotate: '30deg',
              duration: 350,
              easing: "linear",
              complete: options.complete
            })
          }
        })
      }, options, this)()
    }
  }
}

export { devyn_animations }



// WEBPACK FOOTER //
// ./src/components/module_5/js/devyn_animations.js